import { Button, Grid, Paper, Typography } from '@mui/material';
import { WatchlistItem } from '@thro-types/users';

import { t } from 'i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { useWatchlistMutation } from 'api/hooks/watchlist';
import { AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';

import '../styles/Watchlist-Card-Item.scss';

export enum WatchListCategory {
  ARTICLE = 'ARTICLE',
  BULLETIN = 'BULLETIN',
  EVENT = 'EVENT',
  FUNDING = 'FUNDING',
  MODULE_SELECTION = 'MODULE_SELECTION',
  JOB_OFFER = 'JOB_OFFER'
}

export function WatchlistCardItem({ id, title, description, category, link }: WatchlistItem) {
  const { deletion } = useWatchlistMutation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const regexToRemoveHTMLTags = /(<([^>]+)>)/gi;

  const handleDelete = async (watchlistItemId: number) => {
    setLoading(true);
    await deletion
      .mutateAsync(watchlistItemId)
      .then(() => {
        dispatch(AlertActions.success(t(translations.pages.home.watchlist.deleteSuccess())));
      })
      .catch(err => {
        dispatch(AlertActions.error(t(translations.pages.home.watchlist.deleteError())));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Grid container className="watchlist-card-item" component={Paper} elevation={0}>
      <Link to={link}>
        <Grid item container xs gap={2}>
          <img
            style={{ borderRadius: category?.icon?.isRounded ? '50%' : undefined }}
            alt=""
            className="watchlist-card-item__categoryImage"
            src={`${import.meta.env.VITE_S3_IMAGE_PROXY}/${category?.icon?.path}`}
          />
          <Grid item className="watchlist-card-item__body">
            <Typography className="watchlist-card-item__body__title">{title}</Typography>
            <Typography className="watchlist-card-item__body__text">
              {description.replace(regexToRemoveHTMLTags, '')}
            </Typography>
          </Grid>
        </Grid>
      </Link>
      <Grid item container className="watchlist-card-item__action" justifyContent={'flex-end'} xs>
        <Button
          size="small"
          variant={'outlined'}
          disabled={loading}
          onClick={() => handleDelete(id!)}
        >
          X
        </Button>
      </Grid>
    </Grid>
  );
}
